import type { DateTime } from 'luxon';
import { useRegion } from '~/features/region/hooks/useRegion';
import { useLocale } from '~/hooks/useLocale';

export const useDate = () => {
  const { ARegionName } = useRegion();
  const { lang } = useLocale();

  const formatRegionMonth = (date: DateTime) => {
    if (lang === 'ja') {
      return date.toFormat('M');
    }

    if (ARegionName === 'AJP') {
      return date.toFormat('M');
    }

    if (ARegionName === 'AAF') {
      return date.toFormat('LLL');
    }

    return date.toFormat('M');
  };

  const formatRegionDateMD = (date: DateTime) => {
    if (lang === 'ja') {
      return date.toFormat('M/d');
    }

    if (ARegionName === 'AJP') {
      return date.toFormat('M/d');
    }

    if (ARegionName === 'AAF') {
      return date.toFormat('d LLL');
    }

    return date.toFormat('M/d');
  };

  const formatRegionDateYMD = (date: DateTime) => {
    if (lang === 'ja') {
      return date.toFormat('yyyy/M/d');
    }

    if (ARegionName === 'AJP') {
      return date.toFormat('yyyy/M/d');
    }

    if (ARegionName === 'AAF') {
      return date.toFormat('d LLL yyyy');
    }

    return date.toFormat('yyyy/M/d');
  };

  const formatRegionDateYM = (date: DateTime) => {
    if (lang === 'ja') {
      return date.toFormat('yyyy/M');
    }

    if (ARegionName === 'AJP') {
      return date.toFormat('yyyy/M');
    }

    if (ARegionName === 'AAF') {
      return date.toFormat('LLL yyyy');
    }

    return date.toFormat('yyyy/M');
  };

  return { formatRegionDateMD, formatRegionDateYMD, formatRegionMonth, formatRegionDateYM };
};
